// store/rootReducer.js
import { combineReducers } from 'redux';
import authReducer from './authSlice'; // 导入已创建的 Slice
import providerReducer from './providerSlice';

export default combineReducers({
  auth: authReducer, // 模块化命名空间
  provider: providerReducer
});
